import { render } from "./VAS.vue?vue&type=template&id=6dacfa24&scoped=true"
import script from "./VAS.vue?vue&type=script&lang=js"
export * from "./VAS.vue?vue&type=script&lang=js"

import "./VAS.vue?vue&type=style&index=0&id=6dacfa24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dacfa24"]])

export default __exports__